import { IntegrationOrderStatus, IntegrationOrderType } from "@/types";

export const IntegrationOrderTypeColorMap = {
  [IntegrationOrderType.Business]: "cyan",
  [IntegrationOrderType.Customer]: "purple",
};

export const IntegrationOrderStatusColorMap = {
  [IntegrationOrderStatus.Created]: "warning",
  [IntegrationOrderStatus.Submitted]: "orange",
  [IntegrationOrderStatus.Completed]: "green",
  [IntegrationOrderStatus.Deleted]: "gray",
  [IntegrationOrderStatus.Acknowledged]: "blue",
};

export const Ecovacs2CShippingMethods = {
  11: "UP1D",
  12: "UP2D",
  13: "UP3D",
  14: "UPSW",
  16: "ROCO",
  33: "FEDX",
  54: "WLCO",
  65: "FESO",
  67: "FE2D",
  68: "FEES",
  89: "EUPS",
  90: "UPSS",
  91: "UPSN",
  92: "BWPP",
} as const;

export const Ecovacs2BShippingMethods = {
  16: "ROCO",
  92: "BWPP",
} as const;

export const Baseus2CShippingMethods = {
  1: "FedExGroundNew",
  2: "FedEx2DayNew",
  3: "RDY115_FEDEX_2DAY",
  4: "RDY115_FEDEX_GROUND",
  5: "RDY122_GLS_GROUND",
  6: "RDY64_USPS_MIA_OR",
  7: "RDY66_122_UPS_GROUND",
  8: "RDY66_MIAX_UPS",
  9: "RDY84_FEDEX_GROUND",
  10: "RDY84_FEDEX_GROUND_HOME_A",
  11: "RDY84_FEDEX_GROUND_HOME",
  12: "RDY84_FEDEX_GROUND_A",
  13: "RDY84_NEW_FEDEX_GROUND",
  14: "RDY84_NEW_FEDEX_GROUND_A1",
  15: "RDY84_NEW_FEDEX_HOME_DELIVERY",
  16: "RDY84_NEW_FEDEX_HOME_DELIVERY_A1",
  17: "Ups2ndDayAir",
  18: "UpsGround",
  19: "UpsGround1New",
} as const;

export const Baseus2BShippingMethods = {
  110: "DEFAULT",
  120: "TRUCK",
  130: "UPS",
  140: "FEDEX",
} as const;

export function getShippingMethod(customer: string, shippingMethod: number) {
  if (customer === "ECOVACS") {
    return (
      Ecovacs2CShippingMethods[
        shippingMethod as keyof typeof Ecovacs2CShippingMethods
      ] ||
      Ecovacs2BShippingMethods[
        shippingMethod as keyof typeof Ecovacs2BShippingMethods
      ] ||
      "Unknown"
    );
    return "Unknown";
  } else if (customer === "BASEUS") {
    return (
      Baseus2CShippingMethods[
        shippingMethod as keyof typeof Baseus2CShippingMethods
      ] ||
      Baseus2BShippingMethods[
        shippingMethod as keyof typeof Baseus2BShippingMethods
      ] ||
      "Unknown"
    );
  }
  return "Unknown";
}
